import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  FormControl,
  Grid,
  // Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
// import Carousel from 'react-spring-3d-carousel';

// import SimpleModal from '../siFoloModal/index';
import RegisterModal from '../siFoloModal/index';
import LoginModal from '../loginModal/index';
import Loader from '../common/customLoader';
// import AudioModal from '../ivrs/addAudio';
import LanguageContext from '../common/languageContext';
import {
  getHierarchyDataAct,
  setLocationAct,
  setSelectedYearAct,
  setSelectedSeasonAct,
} from '../../Actions/locationHierarchyAction';
import { languageConverter } from '../../Functions/helper';

import {
  getLevelStatsAct,
  setCropRankingParamAct,
  getCropsRegionWiseAct,
  setCropAct,
  getTopCropsAct,
  reportAreaDataAct,
} from '../../Actions/landingPageAction';

import LanguageChangeBuuton from '../common/language_change_button';
import LeftPanelCarousel from './leftPanelCarousel';

const colorArray = ['#0B49CF', '#760BCF', '#CF4C0B', '#ED3214', '#14D3ED'];
// let Carousel;

class LeftPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandLeftPanel: true,
      logginStatus: false,
      areaFlag: true,
      dFlag: false,
      tFlag: false,
      sFlag: false,
    };
    this.handleCropRankingParameter = this.handleCropRankingParameter.bind(
      this,
    );
    this.getData = this.getData.bind(this);
    this.handleCropSelection = this.handleCropSelection.bind(this);
  }

  componentDidMount() {
    /* eslint-disable global-require */
    /* eslint-enable global-require */
    // console.log('hey');
    const { getHierarchyData, history } = this.props;
    getHierarchyData('STATE', null);
    console.log('history', history.location.pathname);
    if (history.location.pathname === '/home') {
      this.setState({
        logginStatus: true,
      });
    }

    // setLocation('STATE', "0a5be76c-bdc2-4405-a32c-c46448ff136b");

    // setLocation('TEHSIL', "8c4233f7-8482-41c6-828c-910538243523");
  }

  componentDidUpdate(prevProps) {
    const {
      states,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      districts,
      tehsils,
    } = this.props;
    const { dFlag, tFlag, sFlag } = this.state;
    // let stateSelected = localStorage.getItem('stateSelected');
    if (states.length && !selectedStateID && !sFlag) {
      setTimeout(() => {
        this.handleLocation(
          {
            target: {
              value: '0a5be76c-bdc2-4405-a32c-c46448ff136b',
            },
          },
          'STATE',
        );
        this.setState({
          sFlag: true,
        });
      }, 3000);
    }

    if (
      districts.length
      && selectedStateID === '0a5be76c-bdc2-4405-a32c-c46448ff136b'
      && !dFlag
    ) {
      this.handleLocation(
        {
          target: {
            value: '8c4233f7-8482-41c6-828c-910538243523',
          },
        },
        'DISTRICT',
      );
      this.updateFlag('dFlag', true);
    }

    if (
      tehsils.length
      && selectedStateID === '0a5be76c-bdc2-4405-a32c-c46448ff136b'
      && selectedDistrictID === '8c4233f7-8482-41c6-828c-910538243523'
      && !tFlag
    ) {
      // setLocation('TEHSIL', "8c4233f7-8482-41c6-828c-910538243523");

      this.handleLocation(
        {
          target: {
            value: 'c1a19d1a-1b05-471b-a871-64ea3460029a',
          },
        },
        'TEHSIL',
      );

      this.updateFlag('tFlag', true);
    }

    const {
      selectedStateID: selectedStateIDprev,
      selectedDistrictID: selectedDistrictIDprev,
      selectedTehsilID: selectedTehsilIDprev,
    } = prevProps;
    if (
      selectedStateID !== selectedStateIDprev
      || selectedDistrictID !== selectedDistrictIDprev
      || selectedTehsilID !== selectedTehsilIDprev
    ) {
      this.updateState(true);
    }
  }

  getData(
    selectedStateIDs,
    selectedDistrictIDs,
    selectedTehsilIDs,
    selectedVillageIDs,
    level,
    cropRankingParam,
    selectedSeason,
    selectedYear,
    cropID,
  ) {
    const data = {};
    data.stateID = selectedStateIDs;
    data.districtID = selectedDistrictIDs;
    data.tehsilID = selectedTehsilIDs;
    data.villageID = selectedVillageIDs;
    data.year = selectedYear;
    data.season = selectedSeason;
    data.cropRankingParam = cropRankingParam;
    data.fetchLevel = level;
    data.cropID = cropID;
    const newData = {};

    Object.keys(data).forEach((item) => {
      if (data[item]) {
        newData[item] = data[item];
      }
    });

    return newData;
  }

  updateFlag = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  updateState = (bool) => {
    this.setState({
      areaFlag: bool,
    });
  };

  expandRankingPanel = (ev) => {
    if (ev.key !== 'Tab') {
      const { expandRankingTable } = this.state;
      this.setState({
        expandRankingTable: !expandRankingTable,
      });
    }
  };

  onBtnClick = () => {
    const { expandLeftPanel } = this.state;
    this.setState({
      expandLeftPanel: !expandLeftPanel,
    });
  };

  handleLogginStatus = (type) => {
    const { cookies, history } = this.props;
    if (type === 'logout') {
      cookies.remove('userData', null);
      cookies.remove('loggedInTimeStamp', null);
      history.push('/');
    } else {
      const userdata = cookies.get('userData');
      if (userdata) {
        if (userdata.data.userRoleData) {
          const roleType = userdata.data.userRoleData.roleName;
          switch (roleType) {
            case 'farmer':
              history.push('/myaccount');
              break;
            default:
              history.push('/dashboard');
              break;
          }
        }
        /* if (userdata.data.roles) {
          const roleType = userdata.data.roles[0].roleName;
          switch (roleType) {
            case 'farmer':
              history.push('/myaccount');
              break;
            default:
              history.push('/dashboard');
              break;
          }
        } else {
          history.push('/tagging');
        } */
      }
    }
    this.setState({
      logginStatus: false,
    });
  };

  handleInformToViewRegion = () => {
    const {
      reportAreaData,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
    } = this.props;
    this.setState({
      areaFlag: false,
    });
    const data = {
      stateID: selectedStateID,
      districtID: selectedDistrictID,
      tehsilID: selectedTehsilID,
    };
    const newData = {};
    Object.keys(data).forEach((item) => {
      if (data[item]) {
        newData[item] = data[item];
      }
    });
    reportAreaData(newData);
  };

  handleCropRankingParameter(event) {
    const {
      setCropRankingParam,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      getLevelStats,
      selectedLevel,
      selectedSeason,
      selectedYear,
    } = this.props;
    setCropRankingParam(event.target.value);
    const level = selectedLevel;
    getLevelStats(
      this.getData(
        selectedStateID,
        selectedDistrictID,
        selectedTehsilID,
        selectedVillageID,
        level,
        event.target.value,
        selectedSeason,
        selectedYear,
      ),
    );
  }

  handleYear(year) {
    const {
      setSelectedYear,
      selectedCropRankingParam,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      getLevelStats,
      selectedLevel,
      selectedSeason,
      getCropsRegionWise,
      getTopCrops,
    } = this.props;

    setSelectedYear(year);

    const data = this.getData(
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      selectedLevel,
      selectedCropRankingParam,
      selectedSeason,
      year,
    );
    getLevelStats(data);
    getCropsRegionWise(data);
    getTopCrops(data);
  }

  handleSeason(season) {
    const {
      setSelectedSeason,
      selectedCropRankingParam,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      getLevelStats,
      selectedLevel,
      selectedYear,
      getCropsRegionWise,
      getTopCrops,
    } = this.props;

    setSelectedSeason(season);

    const data = this.getData(
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      selectedLevel,
      selectedCropRankingParam,
      season,
      selectedYear,
    );
    getCropsRegionWise(data);
    getLevelStats(data);
    getTopCrops(data);
  }

  handleCropSelection(event) {
    const {
      setCrop,
      selectedCropRankingParam,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      getLevelStats,
      selectedLevel,
      selectedSeason,
      selectedYear,
    } = this.props;
    setCrop(event.target.value);
    const data = this.getData(
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      selectedLevel,
      selectedCropRankingParam,
      selectedSeason,
      selectedYear,
      event.target.value,
    );
    getLevelStats(data);
  }

  handleLocation(event, level) {
    const {
      setLocation,
      getHierarchyData,
      getLevelStats,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      fitLevelBounds,
      states,
      districts,
      tehsils,
      villages,
      selectedCropRankingParam,
      selectedSeason,
      selectedYear,
      getCropsRegionWise,
      getTopCrops,
    } = this.props;
    setLocation(level, event.target.value);

    let stateData;
    let districtData;
    let tehsilData;
    let villageData;

    switch (level) {
      case 'STATE': {
        const datas = this.getData(
          event.target.value,
          selectedDistrictID,
          selectedTehsilID,
          selectedVillageID,
          level,
          selectedCropRankingParam,
          selectedSeason,
          selectedYear,
        );
        getLevelStats(datas);
        const params = {
          stateID: event.target.value,
          fetchLevel: 'STATE',
          year: selectedYear,
          season: selectedSeason,
        };
        getCropsRegionWise(params);
        getTopCrops(params);

        getHierarchyData('DISTRICT', event.target.value);
        // if (event.target.value === '92816cda-2573-e6be-e4c5-36c60a735930') {
        /* // Hack for Rajasthan
        const bounds = [
          69.4830322265625,
          23.062043375744096,
          78.26934814453125,
          30.19736606327224,
        ];
        fitLevelBounds('STATE', bounds);
      } else if (
        event.target.value === 'acf296a4-8163-05fe-0e99-985357573d65'
      ) {
        // Hack for Haryana
        const bounds = [
          74.47357177734375,
          27.65190525668953,
          77.60467529296875,
          30.92814479412135,
        ];
        fitLevelBounds('STATE', bounds);
      } else { */
        stateData = states.find(o => o.stateID === event.target.value);
        if (stateData.bounds) {
          fitLevelBounds('STATE', stateData.bounds);
        }
        // }

        break;
      }
      case 'DISTRICT': {
        const datad = this.getData(
          selectedStateID,
          event.target.value,
          selectedTehsilID,
          selectedVillageID,
          level,
          selectedCropRankingParam,
          selectedSeason,
          selectedYear,
        );
        const params = {
          stateID: selectedStateID,
          districtID: event.target.value,
          fetchLevel: 'DISTRICT',
          year: selectedYear,
          season: selectedSeason,
        };
        getCropsRegionWise(params);
        getTopCrops(params);
        getLevelStats(datad);

        getHierarchyData('TEHSIL', event.target.value);
        districtData = districts.find(o => o.districtID === event.target.value);
        if (districtData && districtData.bounds) {
          fitLevelBounds('DISTRICT', districtData.bounds);
        }
        break;
      }
      case 'TEHSIL': {
        const datat = this.getData(
          selectedStateID,
          selectedDistrictID,
          event.target.value,
          selectedVillageID,
          level,
          selectedCropRankingParam,
          selectedSeason,
          selectedYear,
        );
        getLevelStats(datat);
        const params = {
          stateID: selectedStateID,
          districtID: selectedDistrictID,
          tehsilID: event.target.value,
          fetchLevel: 'TEHSIL',
          year: selectedYear,
          season: selectedSeason,
        };
        getCropsRegionWise(params);
        getHierarchyData('VILLAGE', event.target.value);
        tehsilData = tehsils.find(o => o.tehsilID === event.target.value);
        if (tehsilData.bounds) {
          fitLevelBounds('TEHSIL', tehsilData.bounds);
        }
        break;
      }
      case 'VILLAGE': {
        const datav = this.getData(
          selectedStateID,
          selectedDistrictID,
          selectedTehsilID,
          event.target.value,
          level,
          selectedCropRankingParam,
          selectedSeason,
          selectedYear,
        );
        getLevelStats(datav);
        // getCropsRegionWise(datav);
        villageData = villages.find(o => o.villageID === event.target.value);
        if (villageData.bounds) {
          fitLevelBounds('VILLAGE', villageData.bounds);
        }
        break;
      }
      default:
        break;
    }
  }

  render() {
    const { language } = this.context;
    const statesHtml = [];
    const districtHtml = [];
    const tehsilsHtml = [];
    const villagesHtml = [];
    const { expandRankingTable, logginStatus, areaFlag } = this.state;
    const {
      states,
      districts,
      tehsils,
      villages,
      selectedStateID,
      selectedDistrictID,
      selectedTehsilID,
      selectedVillageID,
      levelStats,
      selectedCropRankingParam,
      cropRankingParam,
      selectedSeason,
      selectedYear,
      cropsArray,
      selectedCrop,
      selectedLevel,
      levelStatsFetching,
    } = this.props;
    let cropRankingOptHtml = [];
    cropRankingOptHtml = cropRankingParam.map(item => (
      <MenuItem value={item} key={item}>
        {item}
      </MenuItem>
    ));

    let yearHtml = [];
    yearHtml = [2018, 2019].map(item => (
      <MenuItem value={item} key={item}>
        {item}
      </MenuItem>
    ));

    let seasonHtml = [];
    seasonHtml = [
      { label: 'Kharif', value: 1 },
      { label: 'Rabi', value: 2 },
      // { label: 'Zaid', value: 3 },
    ].map(item => (
      <MenuItem value={item.value} key={item.label}>
        {(language.hindi && language.hindi[item.label]) || item.label}
      </MenuItem>
    ));

    const { cropsRankingResult: cropR, generalStats } = levelStats;
    const cropsRankingResult = cropR.slice(0, 15);

    const cropsHtml = [];
    cropsHtml.push(
      <MenuItem value="" key="Fafsfs">
        {languageConverter('All Crops', language.hindi)}
      </MenuItem>,
    );

    if (cropsArray.length) {
      cropsArray.forEach(item => cropsHtml.push(
        <MenuItem value={item.cropCode} key={item.cropCode}>
          {languageConverter(item.cropName, language.hindi)}
        </MenuItem>,
      ));
      // debugger;
    }

    const {
      totalFarmArea,
      totalFarms,
      averageFarmSize,
      averageFarmRating,
    } = generalStats;

    statesHtml.push(
      <MenuItem value="" key="Fgdfsafsfs" disabled>
        {languageConverter('All State', language.hindi)}
      </MenuItem>,
    );

    if (states.length) {
      states.forEach(item => statesHtml.push(
        <MenuItem key={item.stateID} value={item.stateID}>
          {item.stateName}
        </MenuItem>,
      ));
    }

    districtHtml.push(
      <MenuItem value="" key="Fgderefs" disabled>
        {languageConverter('All Districts', language.hindi)}
      </MenuItem>,
    );

    if (districts.length) {
      districts.forEach(item => districtHtml.push(
        <MenuItem key={item.districtID} value={item.districtID}>
          {item.districtName}
        </MenuItem>,
      ));
    }

    tehsilsHtml.push(
      <MenuItem value="" key="Fgdqwefs" disabled>
        {languageConverter('All Tehsils', language.hindi)}
      </MenuItem>,
    );

    if (tehsils.length) {
      tehsils.forEach((item) => {
        if (item.tehsilID !== '42623d26-734e-4481-b595-43429e097d0f') {
          tehsilsHtml.push(
            <MenuItem key={item.tehsilID} value={item.tehsilID}>
              {item.tehsilName}
            </MenuItem>,
          );
        }
      });
    }

    villagesHtml.push(
      <MenuItem value="" key="Fgipo" disabled>
        {languageConverter('All Villages', language.hindi)}
      </MenuItem>,
    );

    if (villages.length) {
      villages.map(item => villagesHtml.push(
        <MenuItem key={item.villageID} value={item.villageID}>
          {item.villageName}
        </MenuItem>,
      ));
    }

    let lowerLevel = 'District';

    switch (selectedLevel) {
      case 'STATE':
        lowerLevel = 'District';
        break;
      case 'DISTRICT':
        lowerLevel = 'Tehsil';
        break;
      case 'TEHSIL':
        lowerLevel = 'Village';
        break;
      case 'VILLAGE':
        lowerLevel = 'Farm';
        break;
      default:
        break;
    }

    return (
      <Grid item xs={12} sm={5} className="leftPanelMain">
        <Paper className="logoPanel">
          <div className="logoPanelInner">
            <img
              src="/images/logo.svg"
              alt="farmengine-logo"
              title="farmengine-logo"
            />
            <LanguageChangeBuuton />
            {/* <div
              role="presentation"
              className="upDownArrow"
              onClick={this.onBtnClick}
            >
              {expandLeftPanel ? (
                <i className="material-icons">keyboard_arrow_up</i>
              ) : (
                <i className="material-icons">keyboard_arrow_down</i>
              )}
            </div> */}
          </div>
        </Paper>

        {/* <Paper className="headingPanel">
          <h2>
            About Region
            <span>1.2 Hect.</span>
          </h2>
          <Link to="/myfield">This is my field</Link>
        </Paper> */}
        <Paper className="locationPanel">
          <div className="locationPanelInner">
            {`${languageConverter('Year', language.hindi)} `}
            <FormControl className="formControl inputHead coloredForms">
              <Select
                name="landing-year"
                inputProps={{ 'aria-label': 'age' }}
                className="tableDropdown"
                onChange={event => this.handleYear(event.target.value)}
                value={selectedYear}
                disableUnderline
              >
                <MenuItem value="" disabled>
                  {(language.hindi && language.hindi['Select Year'])
                    || 'Select Year'}
                </MenuItem>
                {yearHtml}
              </Select>
            </FormControl>
            {`${languageConverter('of season', language.hindi)} `}

            <FormControl className="formControl inputHead coloredForms">
              <Select
                disableUnderline
                name="landing-season"
                inputProps={{ 'aria-label': 'age' }}
                className="tableDropdown"
                onChange={event => this.handleSeason(event.target.value)}
                value={selectedSeason}
              >
                <MenuItem value="" disabled>
                  {(language.hindi && language.hindi['Select Season'])
                    || 'Select Season'}
                </MenuItem>
                {seasonHtml}
              </Select>
            </FormControl>
            {`${languageConverter('in', language.hindi)} `}
            {/* ,
            <a href="/">2019</a> */}
            {/* <div className=""> */}
            <FormControl className="formControl inputHead coloredForms">
              <Select
                disableUnderline
                name="landing-state"
                inputProps={{ 'aria-label': 'age' }}
                className="tableDropdown"
                onChange={event => this.handleLocation(event, 'STATE')}
                value={selectedStateID}
                displayEmpty
              >
                {statesHtml}
              </Select>
            </FormControl>

            {districts.length ? (
              <React.Fragment>
                {`${languageConverter('in', language.hindi)} `}
                <FormControl className="formControl inputHead coloredForms">
                  <Select
                    disableUnderline
                    name="landing-district"
                    inputProps={{ 'aria-label': 'age' }}
                    className="tableDropdown"
                    onChange={event => this.handleLocation(event, 'DISTRICT')}
                    value={selectedDistrictID}
                    displayEmpty
                  >
                    {districtHtml}
                  </Select>
                </FormControl>
              </React.Fragment>
            ) : null}
            {tehsils.length ? (
              <React.Fragment>
                {`${languageConverter('in', language.hindi)} `}
                <FormControl className="formControl inputHead coloredForms">
                  <Select
                    disableUnderline
                    name="landing-tehsil"
                    inputProps={{ 'aria-label': 'age' }}
                    className="tableDropdown"
                    onChange={event => this.handleLocation(event, 'TEHSIL')}
                    value={selectedTehsilID}
                    displayEmpty
                  >
                    {tehsilsHtml}
                  </Select>
                </FormControl>
              </React.Fragment>
            ) : null}
            {villages.length ? (
              <React.Fragment>
                {`${languageConverter('in', language.hindi)} `}
                <FormControl className="formControl inputHead coloredForms">
                  <Select
                    disableUnderline
                    name="landing-village"
                    inputProps={{ 'aria-label': 'age' }}
                    className="tableDropdown"
                    onChange={event => this.handleLocation(event, 'VILLAGE')}
                    value={selectedVillageID}
                    displayEmpty
                  >
                    {villagesHtml}
                  </Select>
                </FormControl>
              </React.Fragment>
            ) : null}
            {/* </div> */}
          </div>
        </Paper>
        {!levelStatsFetching ? (
          <React.Fragment>
            <Paper className="paper commonStatPanel removeBoxShadow">
              {(totalFarms && Number(totalFarms))
              || totalFarmArea
              || averageFarmSize
              || averageFarmRating ? (
                <ul className="commonBorder">
                  <li>
                    {languageConverter('Total Farms', language.hindi)}

                    <span>{totalFarms}</span>
                  </li>
                  <li>
                    {languageConverter('Total Agri. Area', language.hindi)}

                    <span>
                      {totalFarmArea
                        ? `${Math.floor(totalFarmArea) / 10000}`
                        : ''}
                      {totalFarmArea && <i>ha</i>}
                    </span>
                  </li>
                  <li>
                    {languageConverter('Avg. Farm Size', language.hindi)}

                    <span>
                      {averageFarmSize
                        ? `${Math.floor(averageFarmSize) / 10000}`
                        : ''}
                      {averageFarmSize && <i>ha</i>}
                    </span>
                  </li>
                  <li>
                    {languageConverter('Avg. Farm Ratings', language.hindi)}
                    <span className="custom-tooltip">
                      {averageFarmRating
                        ? `${Math.floor(averageFarmRating * 10000) / 10000}`
                        : ''}
                      <Tooltip title="Avg. Farm Rating">
                        <IconButton aria-label="delete" className="tol-tipBtn">
                          {/* <i className="material-icons custom-info">info</i> */}
                          <i className="custom-info">i</i>
                          {/* <i className="material-icons custom-info">info</i> */}
                        </IconButton>
                      </Tooltip>
                    </span>
                  </li>
                </ul>
                ) : (
                  <ul className="commonBorder">
                    {areaFlag ? (
                      <span style={{ color: '#878787', fontSize: '0.875rem' }}>
                        {languageConverter(
                          'Region not open. If you want to view this region please',
                          language.hindi,
                        )}
                        {' '}
                        <Button
                          style={{
                            color: '#09b466',
                            backgroundColor: 'transparent',
                          }}
                          onClick={() => this.handleInformToViewRegion()}
                        >
                          {languageConverter('Click here', language.hindi)}
                        </Button>
                        {' '}
                        {languageConverter('to inform us', language.hindi)}
                      </span>
                    ) : (
                      <span
                        style={{
                          color: '#878787',
                          fontSize: '0.875rem',
                        // marginBottom: '10px',
                        }}
                      >
                      Thank you for reaching out to us
                      </span>
                    )}
                  </ul>
                )}
            </Paper>
            <Paper className="root tableHead commonPadding">
              <div className="innerTableHead commonBorder">
                <h4>
                  {languageConverter('Ranking of', language.hindi)}
                  {' '}
                  <FormControl className="formControl tableDropdown">
                    <Select
                      name="landing-crop"
                      inputProps={{ 'aria-label': 'age' }}
                      className="tableDropdown"
                      value={selectedCrop}
                      onChange={this.handleCropSelection}
                      disableUnderline
                      displayEmpty
                    >
                      {cropsHtml}
                    </Select>
                  </FormControl>
                  {' '}
                  {languageConverter('by', language.hindi)}
                  {' '}
                  <FormControl className="formControl tableDropdown">
                    <Select
                      name="landing-crop-ranking"
                      inputProps={{ 'aria-label': 'age' }}
                      className="tableDropdown"
                      value={selectedCropRankingParam}
                      onChange={this.handleCropRankingParameter}
                    >
                      <MenuItem value="" disabled>
                        {languageConverter('Parameter', language.hindi)}
                      </MenuItem>
                      {cropRankingOptHtml}
                    </Select>
                  </FormControl>
                </h4>
                <div
                  className={
                    expandRankingTable
                      ? 'rankingTable expandTable'
                      : 'rankingTable'
                  }
                >
                  {cropsRankingResult.length ? (
                    <Table className="table commonTable">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            {languageConverter(lowerLevel, language.hindi)}
                          </TableCell>
                          {cropsRankingResult.length ? (
                            <TableCell>
                              {cropsRankingResult[0].rankingKey.toUpperCase()}
                            </TableCell>
                          ) : null}
                          <TableCell>
                            {languageConverter('Rank', language.hindi)}
                            {' '}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {cropsRankingResult.map((row, index) => (
                          <TableRow key={Math.random()}>
                            <TableCell scope="row">
                              {lowerLevel !== 'Farm'
                                ? row[`${lowerLevel.toLowerCase()}Name`]
                                : row[`${lowerLevel.toLowerCase()}ShortID`]}
                            </TableCell>
                            <TableCell>
                              {row.rankingData
                                ? `${Math.floor(row.rankingData * 10000)
                                    / 10000} ${row.rankingDataUnit}`
                                : ''}
                            </TableCell>
                            <TableCell>
                              <span
                                className="rankValue"
                                style={
                                  index < 5
                                    ? { backgroundColor: colorArray[index] }
                                    : {
                                      backgroundColor:
                                          colorArray[index % colorArray.length],
                                    }
                                }
                              >
                                {index + 1}
                              </span>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : null}
                </div>
                {cropsRankingResult.length >= 3 ? (
                  <div
                    role="button"
                    tabIndex="0"
                    className="showCropBtn"
                    onClick={ev => this.expandRankingPanel(ev)}
                    onKeyUp={ev => this.expandRankingPanel(ev)}
                  >
                    {!expandRankingTable
                      ? languageConverter('Show all regions', language.hindi)
                      : languageConverter('Show few regions', language.hindi)}
                    <i className="material-icons">arrow_downward</i>
                  </div>
                ) : null}
              </div>
            </Paper>
          </React.Fragment>
        ) : (
          <Loader />
        )}
        {/* <Paper className="root farmBtnsHead commonPadding">
          <h4>
            {languageConverter(
              'Is this your farm ? If yes, You can',
              language.hindi,
            )}
          </h4>
          <ul className="greenBtnHeader">
            <li>
              <Button variant="contained" className="button greenBtn">
                {languageConverter(
                  'Generate Credit Worthiness',
                  language.hindi,
                )}
                <Icon className="rightIcon btnIcon">arrow_forward</Icon>
              </Button>
            </li>
            <li>
              <Button
                variant="contained"
                color="primary"
                className="button greenBtn"
              >
                {languageConverter('Find Insurance Rate', language.hindi)}
                <Icon className="rightIcon btnIcon">arrow_forward</Icon>
              </Button>
            </li>
            <li>
              <Button
                variant="contained"
                color="primary"
                className="button greenBtn"
              >
                {languageConverter(
                  'Subscribe for market prices',
                  language.hindi,
                )}
                <Icon className="rightIcon btnIcon">arrow_forward</Icon>
              </Button>
            </li>
            <li>
              <Button
                variant="contained"
                color="primary"
                className="button greenBtn"
              >
                {languageConverter('Apply for Credit Card', language.hindi)}
                <Icon className="rightIcon btnIcon">arrow_forward</Icon>
              </Button>
            </li>
          </ul>
        </Paper> */}

        {/* Weather Report Start */}
        {/* <Paper className="root weatherReportSec commonPadding">
          <h4>Weather Report</h4>
          <img
            src="/images/rain.svg"
            alt="weather-report"
            title="weather-report"
          />
          <h6>
            16˚
            <span>6˚22˚</span>
          </h6>
          <div className="villageInfo">
            {selectedVillageID
              || (selectedTehsilID
                || (selectedDistrictID || (selectedStateID || 'India')))}
            <span>Scattered Thundershowers</span>
          </div>
        </Paper> */}
        {/* Weather Report End */}

        {/* Other Options Start */}
        {/* <Paper className={'root' + ' ' + LeftPanelCSS.weatherReportSec + ' ' +
          CommonCSS.commonPadding}>
          <ul>
            <li>
              <Link to="#">
        </Paper> */}
        {/* Other Options End */}

        <LeftPanelCarousel />

        <Paper className="root knowMoreHead commonPadding greenBtnHeader">
          {/* <div className="infoIPLinks">
            <a
              href="https://info.labs.farmguide.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="./images/info-labs-logo.png"
                alt="info-labs-logo"
                title="info-labs-logo"
              />
              InfoLabs
            </a>
            <a
              href="https://ip.labs.farmguide.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="./images/IPLabs-logo.png"
                alt="ip-labs-logo"
                title="ip-labs-logo"
              />
              IPLabs
            </a>
          </div>
          <Button variant="contained" className="button darkgreenBtn">
            {(language.hindi && language.hindi['Want to Know More'])
              || 'Want to Know More'}
            <Icon className="rightIcon btnIcon">arrow_forward</Icon>
          </Button> */}
          <Link to="/choosePlan" className="howItWorks">
            How it works
          </Link>

          {!logginStatus ? (
            <ul className="siFoloBtnHeader">
              <li>
                <RegisterModal />
              </li>
              {/* <li>or</li> */}
              <li>
                <LoginModal />
              </li>
            </ul>
          ) : (
            <ul className="modalButtons">
              <li className="darkgreenBtnHeader">
                <Button
                  variant="contained"
                  color="primary"
                  className="button darkgreenBtn"
                  onClick={() => this.handleLogginStatus('logout')}
                >
                  Logout
                </Button>
              </li>
              <li className="darkgreenBtnHeader">
                <Button
                  variant="contained"
                  color="primary"
                  className="button darkgreenBtn"
                  onClick={() => this.handleLogginStatus('dashboard')}
                >
                  Go to Dashboard
                </Button>
              </li>
            </ul>
          )}
        </Paper>
      </Grid>
    );
  }
}

LeftPanel.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ location, landing }) => ({
      states: location.state,
      districts: location.district,
      tehsils: location.tehsil,
      villages: location.village,
      selectedStateID: location.selectedStateID,
      selectedDistrictID: location.selectedDistrictID,
      selectedTehsilID: location.selectedTehsilID,
      selectedVillageID: location.selectedVillageID,
      levelStats: landing.levelStats,
      farmStats: landing.farmStats,
      cropRankingParam: landing.cropRankingParam,
      selectedCropRankingParam: landing.selectedCropRankingParam,
      selectedLevel: location.selectedLevel,
      selectedYear: location.selectedYear,
      selectedSeason: location.selectedSeason,
      cropsArray: landing.cropsArray,
      selectedCrop: landing.selectedCrop,
      levelStatsFetching: landing.levelStatsFetching,
    }),

    dispatch => ({
      getHierarchyData: (level, plID) => dispatch(getHierarchyDataAct(level, plID)),
      setLocation: (level, selectedLocation) => dispatch(setLocationAct(level, selectedLocation)),
      getLevelStats: data => dispatch(getLevelStatsAct(data)),
      setCropRankingParam: data => dispatch(setCropRankingParamAct(data)),
      setSelectedYear: year => dispatch(setSelectedYearAct(year)),
      setSelectedSeason: season => dispatch(setSelectedSeasonAct(season)),
      getCropsRegionWise: data => dispatch(getCropsRegionWiseAct(data)),
      getTopCrops: data => dispatch(getTopCropsAct(data)),
      setCrop: data => dispatch(setCropAct(data)),
      reportAreaData: data => dispatch(reportAreaDataAct(data)),
    }),
  )(withCookies(LeftPanel)),
);
